import { render, staticRenderFns } from "./PrefixBanner.vue?vue&type=template&id=205995b1&scoped=true&"
import script from "./PrefixBanner.vue?vue&type=script&lang=js&"
export * from "./PrefixBanner.vue?vue&type=script&lang=js&"
import style0 from "./PrefixBanner.vue?vue&type=style&index=0&id=205995b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205995b1",
  null
  
)

export default component.exports